import React from 'react';

const RatingsLoopIcon = ({color,size}) => {	
    return (
        <span>
           <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} id="loop-down" x="0" y="0" style={{enableBackground:'new 0 0 512 512'}} version="1.1" viewBox="0 0 512 512">
                <g>
                    <g>
                        <path fill="#31ce36" stroke="#31ce36" stroke-width="3"  d="M204.2,245.5c-7.3,0-14.3-3.2-19.1-8.8l-68.9-79.9c-7.5-8.6-6.5-21.7,2.2-29.2c8.6-7.5,21.7-6.5,29.2,2.2l56.7,65.8
                                                   l56.7-65.8c7.5-8.6,20.5-9.6,29.2-2.2c8.6,7.5,9.6,20.5,2.2,29.2l-68.9,79.9C218.4,242.3,211.5,245.5,204.2,245.5z"></path>
                    </g>
                    <g>
                        <path fill="#31ce36" stroke="#31ce36" stroke-width="3"  d="M292.2,512c-29.6,0-57.3-13.3-77.9-37.3c-19.8-23.2-30.7-53.7-30.7-86.1v-54.9c0-11.4,9.3-20.7,20.7-20.7
                                                   s20.7,9.3,20.7,20.7v54.9c0,45.3,30.2,82.1,67.3,82.1s67.3-36.8,67.3-82.1V123.4c0-45.3-30.2-82.1-67.3-82.1s-67.3,36.8-67.3,82.1
                                                   v101.4c0,11.4-9.3,20.7-20.7,20.7s-20.7-9.3-20.7-20.7V123.4c0-32.4,10.9-63,30.7-86.1C234.9,13.3,262.5,0,292.2,0
                                                   s57.3,13.3,77.9,37.3c19.8,23.2,30.7,53.7,30.7,86.1v265.1c0,32.4-10.9,63-30.7,86.1C349.5,498.7,321.8,512,292.2,512z"></path>
                    </g>
                </g>
            </svg>
        </span>
    );
}

RatingsLoopIcon.defaultProps = {
    color:'#ffad46',
    size:'24',
}
export default RatingsLoopIcon;